import { post } from '../../ReactComponents/API';
import { OptimizelySearchTrackingInfo } from './OptimizelySearchTrackingInfo.csharp';

export const SearchQueryParamName = 'searchQuery';

export const trackEpiFindClick = (url: string, position: number, searchTrackingInfo: OptimizelySearchTrackingInfo) => {
    if (searchTrackingInfo) {
        post(
            `${url}?trackId=${searchTrackingInfo.trackId}&query=${searchTrackingInfo.searchQuery}&hitType=${searchTrackingInfo.hitType}&hitId=${searchTrackingInfo.hitId}&position=${position}`
        );
    }
};
